import React, { useContext, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import "./taskComponents.scss";
import { FormControl, Grid, InputLabel, Select, MenuItem, Backdrop, CircularProgress, Typography, Autocomplete, ClickAwayListener, Tooltip, IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import { addMeetingTaskInJira, createJiraTask, getJiraEpics, getJiraProjectComponents, getJiraResponsibleTeam, getJiraUser, updateJiraIssueStatus } from '../../services/jira.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import moment from 'moment';
import { dropDownMenuProps } from '../../utils/components';
import { JIRA_TASK_IN_PROGRESS_STATUS, JIRA_TASK_ISSUE_ID, UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL } from '../../services/const';
import { addMeetingTaskInOpenProject, createOpenProjectTask, getOpenProjectUsers, searchOpenProjectUser } from '../../services/openProject.service';
import { ResponsibleTeamContext } from '../../Pages/IssuePage';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import TinyMCEEditor from '../tinymce';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';

const createSubtaskInfoTooltipMessage = (
  <div>
    <span>Here you schedule a meeting for the selected task.</span>
    <br></br>
    <span> A feedback ticket will be created for the respective person regarding the meeting details.</span>
  </div>
);
interface DialogProps {
  isOpen: boolean;
  onClose: ( isMeetingCreated?:boolean, meetingTaskId?:string ) => void;
}

const getCurrentDate = () => moment().format('YYYY-MM-DD');

const AddMeetingDialog: React.FC<DialogProps> = ({ isOpen, onClose }) => {

  const issueDetails = useSelector((state: RootState) => state.issue);
  const projectState = useSelector((state: RootState) => state.project);
  const userState = useSelector((state: RootState) => state.user);
  const userDetails = userState?.user;
  const selectedProject = projectState?.selectedProject;
  const projectTypeMenu = projectState.projectTypeMenu;
  const projectType = projectState.projectType;
  const userLink = userDetails?.openProjectDetails?._links?.self?.href;
  const selectedProjectLink = projectState?.selectedProject?._links?.createWorkPackageImmediately?.href;

  const [loading, setLoading] = useState(false);
  const [ userList, setUserlist ] = useState<any[]>([]);
  const [fullScreenLoading, setFullScreenLoading] = useState(false);
  const [isScheduledNow,setIsScheduledNow] = useState(false);
  const [isMeetingTypeSelection, setIsMeetingTypeSelection] = useState(true);
  const [isMeetingForTask,setIsMeetingForTask] = useState(false);
  const [epicList, setEpicList] = useState<any[]>([{name:"testing-team",id:"testing"}]);
  const [componentsList, setComponentsList] = useState<any[]>([{name:"testing-components",id:"testing"}]);
  const [userloading, setUserLoading] = useState(false);
  const [userAbortController, setUserAbortController] = useState(new AbortController());
  const [isUserDropDownOpen,setIsUserDropDownOpen] = useState<boolean>(false);
  const [userSearchValue, setUserSearchValue] = useState<string>("");
  const [epicLoading, setEpicLoading] = useState(false);
  const [epicAbortController, setEpicAbortController] = useState(new AbortController());
  const [isEpicDownOpen,setIsEpicDownOpen] = useState<boolean>(false);
  const [selectedEpic,setSelectedEpic] = useState<any>();
  const [epicSearchValue, setEpicSearchValue] = useState<string>("");
  const [componentLoading, setComponentLoading] = useState(false);
  const [selectedComponent,setSelectedComponent] = useState<any>();
  const [componentSearchValue, setComponentSearchValue] = useState<string>("");

  const responsibleTeam = useContext(ResponsibleTeamContext);
  const [responsibleTeamList, setResponsibleTeamList] = useState<any[]>([]);

  const [isInfoToolTipOpen, setIsInfoToolTipOpen] = useState(false);

  const handleScheduleMeetingType = (isNow:boolean) => {
    setIsMeetingTypeSelection(false);
    setIsScheduledNow(isNow);
  }

  const handleClose = ()=>{
    formik.resetForm();
    onClose(false);
    setIsMeetingTypeSelection(true);
    setIsMeetingTypeSelection(true);
  }

  const initialValues = {
    meetingWith : '',
    subject : '',
    description : '',
    dueDate: getCurrentDate(),
    timeEstimation:{
      hours:"",
      minutes:""
    },
    customfield_10009: "",
    components: "",
    customfield_11241: "",

    isMeetingForJiraTask: false,
    isOpenProjectMeeting:false,
  };

  const validationSchema = Yup.object({
    meetingWith: Yup.string().required('meetingWith is required'),
    subject: Yup.string().required('subject is required'),
    description: Yup.string(),
    isOpenProjectMeeting:Yup.boolean().nullable(),
    dueDate: Yup.date().required('Due Date is required'),
    timeEstimation: Yup.object({
      hours: Yup.number(),
      minutes: Yup.number(),
    }).test('at-least-one', 'At least one field (hours, or minutes) must be filled', (value: any) => {
      return value && (value.hours || value.minutes);
    }),
    isMeetingForJiraTask: Yup.boolean().nullable(),
    customfield_10009: Yup.string().when(["isOpenProjectMeeting","isMeetingForJiraTask"],{
      is:(isOpenProjectMeeting: boolean,isMeetingForJiraTask:boolean ) => {
        if (isOpenProjectMeeting) return false;
        if(!isMeetingForJiraTask) return true;
        return false;
      },
      then: (schema)=> schema.required('Epic is required'),
      otherwise: (schema)=> schema.nullable(),
    }),
    components: Yup.string().when(["isOpenProjectMeeting","isMeetingForJiraTask"],{
      is:(isOpenProjectMeeting: boolean,isMeetingForJiraTask:boolean ) => {
        if (isOpenProjectMeeting) return false;
        if(!isMeetingForJiraTask) return true;
        return false;
      },
      then: (schema)=> schema.required('Component is required'),
      otherwise: (schema)=> schema.nullable(),
    }),  
    customfield_11241: Yup.string().when(["isOpenProjectMeeting","isMeetingForJiraTask"],{
      is:(isOpenProjectMeeting: boolean,isMeetingForJiraTask:boolean ) => {
        if (isOpenProjectMeeting) return false;
        if(!isMeetingForJiraTask) return true;
        return false;
      },
      then: (schema)=> schema.required('Responsible Team is required'),
      otherwise: (schema)=> schema.nullable(),
    }),  
  });

  const createMeetingForJiraTask = async (values: typeof initialValues) =>{
    if(!issueDetails?.key){
      return toast.warning('Parent task not selected');
    }

    const payload = {
      issueKey: issueDetails?.key,
      title: values?.subject,
      description : values?.description,
      meetingWith : values?.meetingWith,
      dueDate: values?.dueDate,
      estimationTime: values?.timeEstimation,
      isScheduledNow: isScheduledNow
    };

    setFullScreenLoading(true)
    try {
      let response = await addMeetingTaskInJira(payload) ;
      const reponseData = response?.data;
      if(response?.statusCode == 200 && reponseData?.id )  {
        toast.success('Sub-task created successfully');
        formik.resetForm();
        if(isScheduledNow){
          onClose(true,reponseData?.id);
        }else{
          onClose(true);
        }
        setIsMeetingTypeSelection(true)
      }
    } catch (error) {
      toast.error('Sub-task created failled');
    }finally {
			setFullScreenLoading(false);
		}
  }

  const createMeetingForJiraProject = async (values: typeof initialValues) =>{
    if(!selectedProject?.projectKey){
      return toast.warning('Project not selected');
    }

    const payload = {
      fields: {
          assignee: {
              id: userDetails?.jiraDetails?.accountId
          },
          estimationTime : values?.timeEstimation,
          components: [
              {
                  id: values?.components
              }
          ],
          customfield_11241: {
              id: values?.customfield_11241
          },
          customfield_10009: values?.customfield_10009 || '',
          issuetype: {
              id: JIRA_TASK_ISSUE_ID
          },
          project: {
              id: selectedProject?.id
          },
          labels : [UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL],
          duedate: values?.dueDate,
          summary: values?.subject,
          description: "Create meeting with " + values?.meetingWith +"\n and " +values?.description
        },

    };

    setFullScreenLoading(true);
    try {
      let response = await createJiraTask(payload) ;
      const reponseData = response?.data;
      if(response?.statusCode == 200 && reponseData?.id )  {
        toast.success('task created successfully');
        formik.resetForm();
        if(isScheduledNow){
          const taskStatusUpdatePayload = {
            issueKey: reponseData?.key as string,
            transition: {
                id: JIRA_TASK_IN_PROGRESS_STATUS // for status in progress
            }
          }
          const taskStatusUpdateData = await updateJiraIssueStatus(taskStatusUpdatePayload);
          // for future reference
          // toast.success('Task moved to in progress status');
          onClose(true,reponseData?.id);
        }else{
          onClose(true);
        }
        setIsMeetingTypeSelection(true);
      }
    } catch (error) {
      toast.error('task created failled');
    }finally {
			setFullScreenLoading(false);
		}
  }

  const createMeetingForJira = async(values: typeof initialValues)=>{
    if(isMeetingForTask){
      createMeetingForJiraTask(values);
    }else{
      createMeetingForJiraProject(values);
    }
  }

  const createMeetingForOpenProjectTask = async(values: typeof initialValues) => {
    if(!issueDetails?.key){
      return toast.warning('Parent task not selected');
    }
    const payload = {
      issueKey: `${issueDetails?.key}`,
      title: values?.subject,
      notes : values?.description,
      meetingWith : values?.meetingWith,
      estimatedTime: values?.timeEstimation,
      dueDate:values.dueDate,
      _links: {
        assignee: {
          href: userLink
        }
      }
    };

    setFullScreenLoading(true);
    try {
      let response = await addMeetingTaskInOpenProject(payload) ;
      const reponseData = response;
      if(response?.statusCode == 200)  {
        toast.success('Sub-task created successfully');
        formik.resetForm();
        if(reponseData?.data?.id && isScheduledNow){
          onClose(true,`${reponseData?.data?.id}`);
        }else{
          onClose(true);
        }
        setIsMeetingTypeSelection(true);
      }else{
        toast.error('Sub-task created failled');
      }
    } catch (error) {
      toast.error('Sub-task created failled');
    }finally {
			setFullScreenLoading(false);
		}
  }

  const createMeetingForOpenProjectProject = async(values: typeof initialValues) => {
    
    const payload: Record<string,any> = {
      link: selectedProjectLink,
      subject : values?.subject,
      dueDate:values.dueDate,
      description: {
            raw:  "Create meeting with " + values?.meetingWith +"\n " +values?.description
      },
      customField4: UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL,
      estimatedTime:values.timeEstimation,
      _links: {
          assignee: {
            href: userLink
          }
      }
    };

    setFullScreenLoading(true);
    try {
      let response = await createOpenProjectTask(payload) ;
      const reponseData = response;

      if(response?.statusCode == 200)  {
        toast.success('task created successfully');
        formik.resetForm();
        if(reponseData?.data?.id && isScheduledNow){
          onClose(true,`${reponseData?.data?.id}`);
        }else{
          onClose(true);
        }
        setIsMeetingTypeSelection(true)
      }else{
        toast.error('task created failled');
      }
    } catch (error) {
      toast.error('Task creation failed');
    } finally {
      setFullScreenLoading(false)
    }
  }

  
  const createMeetingForOpenProject = async(values: typeof initialValues)=>{
    if(isMeetingForTask){
      createMeetingForOpenProjectTask(values);
    }else{
      createMeetingForOpenProjectProject(values);
    }
  }

  const onSubmit = async (values: typeof initialValues) => {
    setLoading(true);
    switch (projectType) {
      case (projectTypeMenu[0]): {
        createMeetingForOpenProject(values);
        break;
      }
      case(projectTypeMenu[2]): {
        createMeetingForJira(values)
        break;
      }
    }
  };


  let formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  const getJiraUserList = async(searchValue?:string,abortController?: AbortController) => {
    let userData :any = [];
    setUserLoading(true);
    try {
      const userDataResponse = await getJiraUser({text:searchValue,signal:abortController?.signal});
      userData = userDataResponse?.data;
    } catch (error) {
      userData = [];
    }
    setUserLoading(false);
    return userData;
  }

  const getOpenProjectUserList = async() => {
    let userData = [];
    try {
      const userDataResponse = await searchOpenProjectUser("");
      if(userDataResponse?.statusCode === 200 && userDataResponse?.data?.length > 0) {
        userData = userDataResponse?.data || [];
        userData = userData?.map((user:any) => ({...user,displayName:user.name}))
      }
    } catch (error) {
      userData = [];
    }
    return userData;
  }

  const getUserList = async(value?:string,abortController?: AbortController) => {
    let userListData = [];
    switch(projectType){
      case(projectTypeMenu[0]): {
        userListData = await getOpenProjectUserList()
        break;
      }
      case(projectTypeMenu[2]): {
        userListData = await getJiraUserList(value,abortController);
        break;
      }
    }
    setUserlist([...userListData]);
  }

  const debounce = <F extends (...args: any[]) => void>(func: F, delay: number) => {
    let timer: NodeJS.Timeout;
    return function (this: any, ...args: any[]) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    } as F;
  };

  const debouncedUserSearch = debounce(getUserList, 500); 

  const handleUserChange = (event:any,value:any,reason:any)=>{
    if(reason === "selectOption"){
      formik.setFieldValue("meetingWith",value?.displayName);
    }
    setUserSearchValue(value?.displayName || "");
  }

  const handleUserBlur = (value:any) =>{
    setUserSearchValue(formik.values?.meetingWith || "");
    if(!formik.values?.meetingWith){
      handleUserSearch("","input");
    }
  }

  const handleUserSearch = async (value:any,reason:any) =>{
    
    if( reason === "input" ) {
      if(userAbortController){
        userAbortController.abort();
      }
      const newUserAbortController = new AbortController();
      setUserAbortController(newUserAbortController);
      debouncedUserSearch(value,newUserAbortController);
      setUserSearchValue(value);
    }
  }

  const getEpicList = async (searchText?:string, abortController?: AbortController) =>{
    let epicData :any = [];
    let isCanceled:boolean = false;
    setEpicLoading(true);
    
    try {
      if(selectedProject?.projectKey){
        const epicDataResponse = await getJiraEpics({projectKey:selectedProject?.projectKey,searchText}, abortController?.signal);
        if(epicDataResponse?.message === "canceled"){
          isCanceled = true;
        }
        epicData = epicDataResponse?.data?.issues;
      }
    } catch (error) {
      epicData = [];
    }finally {
      if(isCanceled) return;
      setEpicLoading(false);     
      const newEpicData = Array.isArray(epicData) ? epicData: [];
      setEpicList(newEpicData);    
    }
  }

  const debouncedEpicSearch = debounce(getEpicList, 500); 
  
  const handleEpicSearch = async (value:any,reason:any) =>{    
    if( reason === "input") {
      setEpicSearchValue(value);
      if(epicAbortController){
        epicAbortController.abort();
      }
      const newEpicAbortController = new AbortController();
      setEpicAbortController(newEpicAbortController);
      debouncedEpicSearch(value,newEpicAbortController);
    }
  }

  const handleEpicChange = (event:any,value:any,reason:any)=>{
    if(reason === "selectOption"){
      setSelectedEpic(value);
      formik.setFieldValue("customfield_10009",value?.key);
      setEpicSearchValue(value?.fields?.summary || "");
    }
  }

  const handleEpicBlur = (value:any) =>{
    setEpicSearchValue(selectedEpic?.fields?.summary || "");
    if(!selectedEpic?.fields?.summary){
      handleEpicSearch("","input");
    }
  }
  const handleComponentSearch = async (value:any,reason:any) =>{    
    if( reason === "input") {
      setComponentSearchValue(value);
    }
  }

  const handleComponentChange = (event:any,value:any,reason:any)=>{
    if(reason === "selectOption"){
      setSelectedComponent(value);
      formik.setFieldValue("components",value?.id);
      setComponentSearchValue(value?.name || "");
    }
  }

  const handleComponentBlur = (value:any) =>{
    setComponentSearchValue(selectedComponent?.name || "");
  }

  const getProjectComponentsList = async () =>{
    let componentData :any = [];
    try {
      setComponentLoading(true)
      if(selectedProject?.projectKey){
        const componentDataResponse = await getJiraProjectComponents(selectedProject?.projectKey);
        componentData = componentDataResponse?.data;
      }
    } catch (error) {
      componentData = [];
    } finally {
      setComponentLoading(false);
    }
    if(Array.isArray(componentData)){
      setComponentsList(componentData);
    }else{
      setComponentsList([]);
    }
  }
  
  useEffect(()=>{
    const abortController:AbortController  = new AbortController();
    if(projectType && isOpen){
      getUserList(undefined,abortController);
    }
    return ()=>{
      abortController.abort();
   }
  },[projectType,isOpen]);

  useEffect(()=>{
    if (projectType === projectTypeMenu[2]) {
      // getResponsibleTeamList();
    }else {
      setEpicList([]);
      setUserlist([]);
      setComponentsList([]);
    }
  },[projectType]);

  useEffect(()=>{
    if ((projectType === projectTypeMenu[2]) && isOpen) {
      getProjectComponentsList()
      getEpicList()
    }else {
      setEpicList([])
      // setResponsibleTeamList([])
      setComponentsList([])
    }
  },[selectedProject,isOpen]);

  useEffect(()=>{
    if(isOpen){
      if(issueDetails?.id){
        setIsMeetingForTask(true);
        formik.setFieldValue("isMeetingForJiraTask",true);
      }else{
        setIsMeetingForTask(false)
        formik.setFieldValue("isMeetingForJiraTask",false);
      }
      if (projectType === projectTypeMenu?.[0]) {
        formik.setFieldValue("isOpenProjectMeeting",true);
      }
      setUserSearchValue("");
      setEpicSearchValue("");
      setSelectedEpic({});
      setComponentSearchValue("");
      setSelectedComponent({});
    }
  },[isOpen]);

  useEffect(() => {
    setResponsibleTeamList([...responsibleTeam]);
  }, [responsibleTeam]);

  if(isMeetingTypeSelection) {
    return (
      <>
      <Dialog open={isOpen}>
        <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>Meeting Schedule
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize='small'/>
          </IconButton>
        </DialogTitle>
        <DialogContent>
            <div style={{paddingBottom:"20px"}}>
              Is Meeting held Now or later ?
            </div>
            <div className='action-button-container'>
              <Button className='confirm-btn' variant="contained" color="primary" onClick={()=>handleScheduleMeetingType(true)} >
                Now
              </Button>
              <Button variant="contained" color="primary" onClick={()=>handleScheduleMeetingType(false)} >
                Later
              </Button>
            </div>
        </DialogContent>
      </Dialog>
      </>
    )
  }

  return (
    
      <Dialog
      maxWidth={"xl"}
      open={isOpen}
      className="create-task-dialog-container"
    >
      {loading && (
        <div className="circular-progress-loader-backdrop">
          <div className="circular-progress-loader" >
            <CircularProgress />
          </div>
        </div>
      )}
        <DialogTitle>
        <div className='title-container'>
            <span>Create Meeting</span>

            <ClickAwayListener onClickAway={(e)=>setIsInfoToolTipOpen(false)}>
              <div>
                <Tooltip
                  title={createSubtaskInfoTooltipMessage}
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={(e)=>setIsInfoToolTipOpen(false)}
                  open={isInfoToolTipOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                >
                  <Button className='info-button'  onClick={(e)=>setIsInfoToolTipOpen(true)}><InfoIcon className='info-icon'/></Button>
                </Tooltip>
              </div>
            </ClickAwayListener>
          </div>
        </DialogTitle>
        <form onSubmit={formik.handleSubmit} className="dialog-form">
        <DialogContent className="create-sub-task-dialog-content" >
              <div>
              {!!issueDetails?.id && (
                  <TextField
                    label="Selected Task"
                    value={`${issueDetails?.key || ''} ${issueDetails?.issue || ''}`}
                    disabled
                    fullWidth
                    margin="normal"
                  />
                )
              }

                { projectType !== projectTypeMenu[0] ? <Autocomplete
                    open={isUserDropDownOpen}
                    onOpen={() => {
                      setIsUserDropDownOpen(true);
                    }}
                    onClose={() => {
                      setIsUserDropDownOpen(false);
                    }}
                    onInputChange={(_,value,reason)=>handleUserSearch(value,reason)}
                    options={userList}
                    loading={userloading}
                    loadingText="Loading..."
                    isOptionEqualToValue={(option, value) => option?.accountId === value?.accountId}
                    getOptionLabel={(option) => option?.displayName}
                    onChange={handleUserChange}
                    onBlur={handleUserBlur}
          					ListboxProps={{style:{maxHeight:250}}}
                    inputValue={userSearchValue}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="meetingWith"
                        error={formik.touched.meetingWith && Boolean(formik.errors.meetingWith)}
                        label="Meeting With"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {userloading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  /> : 
                  <Autocomplete
                    open={isUserDropDownOpen}
                    onOpen={() => {
                      setIsUserDropDownOpen(true);
                    }}
                    onClose={() => {
                      setIsUserDropDownOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    getOptionLabel={(option) => `${option.name}`}
                    options={userList}
                    loading={userloading}
                    renderOption={(props, option) => (
                      <li {...props} key={option?.id}>
                        {option?.name}
                      </li>
                    )}
                    onChange={handleUserChange}
                    onBlur={handleUserBlur}
          					ListboxProps={{style:{maxHeight:250}}}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="meetingWith"
                        error={formik.touched.meetingWith && Boolean(formik.errors.meetingWith)}
                        label="Meeting With"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {userloading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                  }
                
                  <TextField
                      required
                      label="Subject"
                      type="text"
                      name="subject"
                      value={formik.values.subject}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.subject && Boolean(formik.errors.subject)}
                      helperText={formik.touched.subject && formik.errors.subject}
                      fullWidth
                      style={{marginTop:"10px", marginBottom:"10px"}}
                    />

                  <TextField
                      multiline
                      rows={3}
                      label="Description"
                      type="text"
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.description && Boolean(formik.errors.description)}
                      helperText={formik.touched.description && formik.errors.description}
                      fullWidth
                      margin="normal"
                    />

                    {
                      projectType == projectTypeMenu[2] && !isMeetingForTask &&
                        <>
                          <div className='select-form-control-container'>
                            <Autocomplete
                              open={isEpicDownOpen}
                              onOpen={() => {
                                setIsEpicDownOpen(true);
                              }}
                              onClose={() => {
                                setIsEpicDownOpen(false);
                              }}
                              onInputChange={(_,value,reason)=>handleEpicSearch(value,reason)}
                              options={epicList}
                              loading={epicLoading}
                              loadingText="Loading..."
                              isOptionEqualToValue={(option, value) => option?.key === value?.key}
                              getOptionLabel={(option) => option?.fields?.summary}
                              onChange={handleEpicChange}
                              onBlur={handleEpicBlur}
                              ListboxProps={{style:{maxHeight:250}}}
                              inputValue={epicSearchValue}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="customfield_10009"
                                  error={formik.touched.customfield_10009 && Boolean(formik.errors.customfield_10009)}
                                  label="Epic"
                                  variant="outlined"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {epicLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </div>
                          <div className='select-form-control-container'>
                            <Autocomplete
                              onInputChange={(_,value,reason)=>handleComponentSearch(value,reason)}
                              options={componentsList}
                              loading={componentLoading}
                              loadingText="Loading..."
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              getOptionLabel={(option) => option?.name}
                              onChange={handleComponentChange}
                              onBlur={handleComponentBlur}
                              ListboxProps={{style:{maxHeight:250}}}
                              inputValue={componentSearchValue}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="components"
                                  error={formik.touched.components && Boolean(formik.errors.components)}
                                  label="Components"
                                  variant="outlined"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {componentLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </div>

                          <div className='select-form-control-container'>
                            <FormControl className='add-meeting-select-form-control' fullWidth >	
                            <InputLabel className='bg-white' id="Team-label"> Responsible Team </InputLabel>
                            <Select
                            labelId="Team-label"
                              name="customfield_11241"
                              label="Responsible Team"
                              variant="outlined"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.customfield_11241}
                              error={formik.touched.customfield_11241 && Boolean(formik.errors.customfield_11241)}
                              fullWidth
                              MenuProps={dropDownMenuProps}
                            >
                              {
                                responsibleTeamList?.map((team:any)=> (
                                  <MenuItem key={team?.id} value={team?.id}>{team?.value}</MenuItem>
                                ))
                              }
                              </Select>
                            </FormControl>
                          </div>
                        </>
                    }
                
                    <Grid>
                      <Grid item xs={12}>
                          <Typography  gutterBottom>
                            Time Estimation
                          </Typography>
                        </Grid>
                        <Grid container spacing={2}>

                        <Grid item xs={6}>
                          <FormControl fullWidth error={Boolean(formik.errors.timeEstimation && formik.touched.timeEstimation)}>
                            <InputLabel className='bg-white' id="timeEstimation-hours-label">Hours</InputLabel>
                            <Select
                              labelId="timeEstimation-hours-label"
                              id="timeEstimation.hours"
                              name="timeEstimation.hours"
                              value={formik.values.timeEstimation.hours}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={formik.touched.timeEstimation?.hours && Boolean(formik.errors.timeEstimation?.hours)}
                            >
                              <MenuItem className='empty-select-item' value=""></MenuItem>

                              <MenuItem value="1">1</MenuItem>
                              <MenuItem value="2">2</MenuItem>
                              <MenuItem value="3">3</MenuItem>
                              <MenuItem value="4">4</MenuItem>
                              <MenuItem value="5">5</MenuItem>
                              <MenuItem value="6">6</MenuItem>
                              <MenuItem value="7">7</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl fullWidth error={Boolean(formik.errors.timeEstimation && formik.touched.timeEstimation)}>
                            <InputLabel className='bg-white' id="timeEstimation-minutes-label"> Minutes </InputLabel>
                            <Select
                              required
                              labelId="timeEstimation-minutes-label"
                              id="timeEstimation.minutes"
                              name="timeEstimation.minutes"
                              value={formik.values.timeEstimation.minutes}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={formik.touched.timeEstimation?.minutes && Boolean(formik.errors.timeEstimation?.minutes)}
                            >
                              <MenuItem className='empty-select-item' value=""></MenuItem>

                              <MenuItem value="15">15</MenuItem>
                              <MenuItem value="30">30</MenuItem>
                              <MenuItem value="45">45</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>

                    <TextField
                      required
                      label="Due Date"
                      type="date"
                      name="dueDate"
                      value={formik.values.dueDate}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.dueDate && Boolean(formik.errors.dueDate)}
                      helperText={formik.touched.dueDate && formik.errors.dueDate}
                      fullWidth
                      margin="normal"
                    />

              </div>
              </DialogContent>

        <DialogActions className="fixed-footer">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >


            <Button variant="contained" color="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading} variant="contained" color="primary">
              {loading ? "Submitting" : "Submit"}
            </Button>
          </Box>
        </DialogActions>

      </form>

      <Backdrop open={fullScreenLoading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress />
      </Backdrop>
    </Dialog>



  );
};


export default AddMeetingDialog;
